"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Container_1 = __importDefault(require("../../Atoms/Container/Container"));
var SieccaoLogo_1 = __importDefault(require("./SieccaoLogo"));
var SieccaoLogo = function (_a) {
    var content = _a.content;
    function renderRegisterLogo() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container_1.default, { className: 'mobile' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 42, color: false, id: 'register-mobile-cgsp' })),
            react_1.default.createElement(Container_1.default, { className: 'desktop' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 156, height: 67, color: false, id: 'register-desktop-cgsp' }))));
    }
    function renderHeaderLogo() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container_1.default, { className: 'mobile' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 42, color: false, id: 'header-mobile-cgsp' })),
            react_1.default.createElement(Container_1.default, { className: 'desktop' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 54, color: false, id: 'header-desktop-cgsp' }))));
    }
    function renderFooterLogo() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container_1.default, { className: 'mobile' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 42, color: true, id: 'footer-mobile-cgsp' })),
            react_1.default.createElement(Container_1.default, { className: 'desktop' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 42, color: true, id: 'footer-desktop-cgsp' }))));
    }
    function renderLoginLogo() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container_1.default, { className: 'mobile' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 84, height: 42, color: false, id: 'login-mobile-cgsp' })),
            react_1.default.createElement(Container_1.default, { className: 'desktop' },
                react_1.default.createElement(SieccaoLogo_1.default, { width: 200, height: 120, color: false, id: 'login-desktop-cgsp' }))));
    }
    return (react_1.default.createElement(Container_1.default, { className: 'sds-brand-logo' },
        content === 'header' && renderHeaderLogo(),
        content === 'footer' && renderFooterLogo(),
        content === 'login' && renderLoginLogo(),
        content === 'register' && renderRegisterLogo()));
};
exports.default = SieccaoLogo;
